export const normalizeAnimationSpeed = (length: number) =>
  Math.min(0.0075 * length, 4);
